var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_3773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5391 18.1793V16.0417C16.5391 14.5255 17.7729 13.2917 19.2891 13.2917C20.8052 13.2917 22.0391 14.5255 22.0391 16.0417V17.875C22.1344 17.875 22.2242 17.897 22.3177 17.9062C23.0205 17.1504 23.4121 16.1571 23.4141 15.125C23.4141 14.031 22.9795 12.9818 22.2059 12.2082C21.4323 11.4346 20.3831 11 19.2891 11C18.195 11 17.1458 11.4346 16.3722 12.2082C15.5987 12.9818 15.1641 14.031 15.1641 15.125C15.1641 16.3423 15.7012 17.424 16.5391 18.1793Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9167 21.0846C28.552 21.0846 28.2023 21.2295 27.9444 21.4874C27.6865 21.7452 27.5417 22.095 27.5417 22.4596V22.6888C27.5417 22.7496 27.5175 22.8079 27.4745 22.8508C27.4316 22.8938 27.3733 22.918 27.3125 22.918C27.2517 22.918 27.1934 22.8938 27.1505 22.8508C27.1075 22.8079 27.0833 22.7496 27.0833 22.6888V21.543C27.0833 21.1783 26.9385 20.8286 26.6806 20.5707C26.4227 20.3128 26.073 20.168 25.7083 20.168C25.3437 20.168 24.9939 20.3128 24.7361 20.5707C24.4782 20.8286 24.3333 21.1783 24.3333 21.543V22.6888C24.3333 22.7496 24.3092 22.8079 24.2662 22.8508C24.2232 22.8938 24.1649 22.918 24.1042 22.918C24.0434 22.918 23.9851 22.8938 23.9421 22.8508C23.8991 22.8079 23.875 22.7496 23.875 22.6888V20.6263C23.875 20.2616 23.7301 19.9119 23.4723 19.654C23.2144 19.3962 22.8647 19.2513 22.5 19.2513C22.1353 19.2513 21.7856 19.3962 21.5277 19.654C21.2699 19.9119 21.125 20.2616 21.125 20.6263V22.6888C21.125 22.7496 21.1009 22.8079 21.0579 22.8508C21.0149 22.8938 20.9566 22.918 20.8958 22.918C20.8351 22.918 20.7768 22.8938 20.7338 22.8508C20.6908 22.8079 20.6667 22.7496 20.6667 22.6888V16.043C20.6667 15.6783 20.5218 15.3286 20.2639 15.0707C20.0061 14.8128 19.6563 14.668 19.2917 14.668C18.927 14.668 18.5773 14.8128 18.3194 15.0707C18.0615 15.3286 17.9167 15.6783 17.9167 16.043V24.293C17.7951 24.293 17.6785 24.2447 17.5926 24.1587C17.5066 24.0728 17.4583 23.9562 17.4583 23.8346V22.0013H17.0055C15.4976 22.0013 14.2491 23.2186 14.25 24.7266C14.2546 29.5675 17.7783 33.0013 19.9453 33.0013H25.7083C26.3102 33.0013 26.9062 32.8828 27.4623 32.6524C28.0184 32.4221 28.5236 32.0845 28.9492 31.6589C29.3748 31.2333 29.7124 30.728 29.9428 30.1719C30.1731 29.6159 30.2917 29.0199 30.2917 28.418V22.4596C30.2917 22.095 30.1468 21.7452 29.8889 21.4874C29.6311 21.2295 29.2813 21.0846 28.9167 21.0846Z",
    fill: "#7a7a7a"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_3773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11.5 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/selectIcon.db7a6964.svg";
export { ForwardRef as ReactComponent };